import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const ListIcon = ({ color, size = 24, sx, ...props }: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.81815 20L1.28782 19.4697C1.07333 19.6842 1.00916 20.0068 1.12524 20.287C1.24133 20.5673 1.51481 20.75 1.81815 20.75V20ZM3.2727 4H4.0227V3.25H3.2727V4ZM8.36361 12.0227H22.9091V10.5227H8.36361V12.0227ZM8.36361 6.20455H22.9091V4.70455H8.36361V6.20455ZM8.36361 17.8409H22.9091V16.3409H8.36361V17.8409ZM5.45452 19.25H1.81815V20.75H5.45452V19.25ZM2.34848 20.5303L4.95633 17.9225L3.89567 16.8618L1.28782 19.4697L2.34848 20.5303ZM3.69873 14.8864H3.2727V16.3864H3.69873V14.8864ZM3.2727 14.8864C2.05516 14.8864 1.06815 15.8734 1.06815 17.0909H2.56815C2.56815 16.7018 2.88359 16.3864 3.2727 16.3864V14.8864ZM5.47725 16.6649C5.47725 15.6826 4.68097 14.8864 3.69873 14.8864V16.3864C3.85255 16.3864 3.97725 16.5111 3.97725 16.6649H5.47725ZM4.95633 17.9225C5.28987 17.5889 5.47725 17.1366 5.47725 16.6649H3.97725C3.97725 16.7388 3.9479 16.8096 3.89567 16.8618L4.95633 17.9225ZM1.09088 9.11364H5.45452V7.61364H1.09088V9.11364ZM4.0227 8.36364V4H2.5227V8.36364H4.0227ZM3.2727 3.25H1.09088V4.75H3.2727V3.25Z"
        fill={iconColor}
      />
    </Box>
  );
};
